<template>
  <div class="dashboard-page">
    <!-- Header -->
    <header class="header">
      <div class="header-content">
        <div class="brand">
          <div class="brand-badge">B</div>
          <div>
            <h1>BEZ Capital</h1>
            <div class="muted">客户仪表盘</div>
          </div>
        </div>
        <div class="header-actions">
          <div class="last-update-info" v-if="lastNavUpdateDate">
            <span class="update-label">最近更新:</span>
            <span class="update-date">{{ lastNavUpdateDate }}</span>
          </div>
          <span class="user-email">{{ userEmail }}</span>
          <button class="btn-secondary" @click="handleLogout">退出登录</button>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <div class="main-content">
      <div class="container">
        <!-- Overview Cards -->
        <div class="overview-section">
          <div class="stat-card primary">
            <div class="stat-label">当前账户总价值</div>
            <div class="stat-value">{{ formatCurrency(currentValue) }}</div>
            <div class="stat-note">当前净值 = {{ currentPoolNavValue.toFixed(2) }}</div>
          </div>

          <div class="stat-card">
            <div class="stat-label">当日收益</div>
            <div class="stat-value" :class="dailyChangeClass">
              {{ formatChange(dailyChange) }}
            </div>
            <div class="stat-note">相较于昨日</div>
          </div>

          <div class="stat-card">
            <div class="stat-label">7天收益</div>
            <div class="stat-value" :class="weekChangeClass">
              {{ formatChange(weekChange) }}
            </div>
            <div class="stat-note">最近7天变化</div>
          </div>

          <div class="stat-card">
            <div class="stat-label">30天收益</div>
            <div class="stat-value" :class="monthChangeClass">
              {{ formatChange(monthChange) }}
            </div>
            <div class="stat-note">最近30天变化</div>
          </div>
        </div>

        <!-- Chart Section -->
        <div class="chart-section">
          <div class="section-header">
            <h2>历史净值曲线</h2>
            <div class="chart-controls">
              <button
                v-for="period in periods"
                :key="period.value"
                :class="['period-btn', { active: selectedPeriod === period.value }]"
                @click="changePeriod(period.value)"
              >
                {{ period.label }}
              </button>
            </div>
          </div>
          <div class="chart-container">
            <v-chart
              v-if="chartOption"
              :option="chartOption"
              :autoresize="true"
              class="chart"
            />
            <div v-else class="chart-empty">暂无数据</div>
          </div>
        </div>

        <!-- Return Rate Chart Section -->
        <div class="chart-section">
          <div class="section-header">
            <h2>收益率曲线</h2>
            <div class="chart-controls">
              <button
                v-for="period in periods"
                :key="period.value"
                :class="['period-btn', { active: selectedPeriod === period.value }]"
                @click="changePeriod(period.value)"
              >
                {{ period.label }}
              </button>
            </div>
          </div>
          <div class="chart-container">
            <v-chart
              v-if="returnChartOption"
              :option="returnChartOption"
              :autoresize="true"
              class="chart"
            />
            <div v-else class="chart-empty">暂无数据</div>
          </div>
        </div>

        <!-- Pool Info Section -->
        <!-- <div class="pool-section" v-if="poolInfo.length > 0"> -->
          <!-- <h2>我的策略池</h2>
          <div class="pool-grid">
            <div class="pool-card" v-for="pool in poolInfo" :key="pool.pool_id">
              <div class="pool-header">
                <div class="pool-name">{{ pool.pool_name }}</div>
                <div class="pool-id">{{ pool.pool_id }}</div>
              </div>
              <div class="pool-stats"> -->
                <!-- <div class="pool-stat">
                  <span class="label">我的权重</span>
                  <span class="value">{{ pool.weight ? (pool.weight * 100).toFixed(2) + '%' : '-' }}</span>
                </div> -->
                <!-- <div class="pool-stat">
                  <span class="label">初始金额</span>
                  <span class="value">{{ formatCurrency(pool.amount) }}</span>
                </div> -->
              <!-- </div>
            </div>
          </div> -->
        <!-- </div> -->

        <!-- History Tables with Tabs -->
        <!-- <div class="history-section"> -->
          <!-- <div class="section-header">
            <h2>历史记录</h2>
            <div class="history-tabs">
              <button
                :class="['tab-btn', { active: activeHistoryTab === 'nav' }]"
                @click="activeHistoryTab = 'nav'"
              >
                净值历史
              </button>
              <button
                :class="['tab-btn', { active: activeHistoryTab === 'return' }]"
                @click="activeHistoryTab = 'return'"
              >
                收益率历史
              </button>
            </div>
          </div> -->

          <!-- NAV History Table -->
          <!-- <div v-if="activeHistoryTab === 'nav'"> -->
            <!-- <div class="date-filter">
              <label>开始日期：</label>
              <input type="date" v-model="navStartDate" class="date-input" />
              <label>结束日期：</label>
              <input type="date" v-model="navEndDate" class="date-input" />
              <button @click="navStartDate = ''; navEndDate = ''" class="reset-btn">重置</button>
            </div> -->
            <!-- <div class="table-container"> -->
              <!-- <table> -->
                <!-- <thead>
                  <tr>
                    <th>日期</th>
                    <th>策略池</th>
                    <th>净值金额</th>
                    <th>日变化</th>
                  </tr>
                </thead> -->
                <!-- <tbody>
                  <tr v-for="(record, index) in paginatedNavRecords" :key="index">
                    <td>{{ record.date }}</td>
                    <td>{{ record.pool_id || '-' }}</td>
                    <td class="amount">{{ formatNavValue(record.nav_amount) }}</td>
                    <td :class="getChangeClass(record.change)">
                      {{ record.change ? formatChange(record.change) : '-' }}
                    </td>
                  </tr>
                  <tr v-if="paginatedNavRecords.length === 0">
                    <td colspan="4" class="empty">暂无净值记录</td>
                  </tr>
                </tbody>
              </table> -->
            <!-- </div> -->
            <!-- <div class="pagination" v-if="navTotalPages > 1">
              <button @click="navPrevPage" :disabled="navCurrentPage === 1" class="page-btn">上一页</button>
              <span class="page-info">第 {{ navCurrentPage }} / {{ navTotalPages }} 页（共 {{ filteredNavRecords.length }} 条）</span>
              <button @click="navNextPage" :disabled="navCurrentPage === navTotalPages" class="page-btn">下一页</button>
            </div>
          </div> -->

          <!-- Return Rate History Table -->
          <div v-if="activeHistoryTab === 'return'">
            <div class="date-filter">
              <label>开始日期：</label>
              <input type="date" v-model="returnStartDate" class="date-input" />
              <label>结束日期：</label>
              <input type="date" v-model="returnEndDate" class="date-input" />
              <button @click="returnStartDate = ''; returnEndDate = ''" class="reset-btn">重置</button>
            </div>
            <div class="table-container">
              <table>
                <thead>
                  <tr>
                    <th>日期</th>
                    <th>策略池</th>
                    <th>净值金额</th>
                    <th>累计收益率</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(record, index) in paginatedReturnRecords" :key="index">
                    <td>{{ record.date }}</td>
                    <td>{{ record.pool_id || '-' }}</td>
                    <td class="amount">{{ formatCurrency(record.nav_amount) }}</td>
                    <td :class="getReturnClass(record.return_rate)">
                      {{ formatReturnRate(record.return_rate) }}
                    </td>
                  </tr>
                  <tr v-if="paginatedReturnRecords.length === 0">
                    <td colspan="4" class="empty">暂无收益率记录</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="pagination" v-if="returnTotalPages > 1">
              <button @click="returnPrevPage" :disabled="returnCurrentPage === 1" class="page-btn">上一页</button>
              <span class="page-info">第 {{ returnCurrentPage }} / {{ returnTotalPages }} 页（共 {{ filteredReturnRecords.length }} 条）</span>
              <button @click="returnNextPage" :disabled="returnCurrentPage === returnTotalPages" class="page-btn">下一页</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
} from 'echarts/components'
import VChart from 'vue-echarts'

// 注册 ECharts 组件
use([
  CanvasRenderer,
  LineChart,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
])

export default {
  name: 'DashboardPage',
  components: {
    VChart
  },
  data() {
    return {
      userEmail: '',
      clientInfo: {},
      navRecords: [],
      poolInfo: [],
      lastNavUpdateDate: '', // 最近更新净值的日期
      currentPoolNavValue: 1.0, // 当前池子净值
      currentValue: 0,
      dailyChange: 0,
      weekChange: 0,
      monthChange: 0,
      selectedPeriod: '30',
      periods: [
        { label: '7天', value: '7' },
        { label: '30天', value: '30' },
        { label: '全部', value: 'all' }
      ],
      chartOption: null,
      returnChartOption: null, // 收益率曲线图表配置
      // 历史记录 Tab 切换
      activeHistoryTab: 'nav', // 'nav' 或 'return'
      // 净值历史记录分页和筛选
      navStartDate: '',
      navEndDate: '',
      navCurrentPage: 1,
      navPageSize: 10,
      // 收益率历史记录分页和筛选
      returnStartDate: '',
      returnEndDate: '',
      returnCurrentPage: 1,
      returnPageSize: 10
    }
  },
  computed: {
    dailyChangeClass() {
      return this.dailyChange > 0 ? 'positive' : this.dailyChange < 0 ? 'negative' : ''
    },
    weekChangeClass() {
      return this.weekChange > 0 ? 'positive' : this.weekChange < 0 ? 'negative' : ''
    },
    monthChangeClass() {
      return this.monthChange > 0 ? 'positive' : this.monthChange < 0 ? 'negative' : ''
    },
    // 净值历史记录 - 过滤
    filteredNavRecords() {
      let records = [...this.navRecords]

      // 过滤掉早于客户加入日期的记录
      if (this.clientInfo.joinDate) {
        records = records.filter(r => r.date >= this.clientInfo.joinDate)
      }

      // 日期筛选
      if (this.navStartDate) {
        records = records.filter(r => r.date >= this.navStartDate)
      }
      if (this.navEndDate) {
        records = records.filter(r => r.date <= this.navEndDate)
      }

      return records
    },
    // 净值历史记录 - 分页
    paginatedNavRecords() {
      const start = (this.navCurrentPage - 1) * this.navPageSize
      const end = start + this.navPageSize
      return this.filteredNavRecords.slice(start, end)
    },
    // 净值历史记录 - 总页数
    navTotalPages() {
      return Math.ceil(this.filteredNavRecords.length / this.navPageSize)
    },
    // 收益率历史记录 - 计算收益率
    returnRecords() {
      if (!this.navRecords || this.navRecords.length === 0) return []

      let records = [...this.navRecords]

      // 过滤掉早于客户加入日期的记录
      if (this.clientInfo.joinDate) {
        records = records.filter(r => r.date >= this.clientInfo.joinDate)
      }

      records = records.reverse() // 从旧到新
      if (records.length === 0) return []

      const initialValue = records[0].nav_amount

      return records.map(r => ({
        date: r.date,
        pool_id: r.pool_id,
        nav_amount: r.nav_amount,
        return_rate: ((r.nav_amount - initialValue) / initialValue * 100).toFixed(2)
      })).reverse() // 反转回最新的在前
    },
    // 收益率历史记录 - 过滤
    filteredReturnRecords() {
      let records = [...this.returnRecords]

      // 日期筛选
      if (this.returnStartDate) {
        records = records.filter(r => r.date >= this.returnStartDate)
      }
      if (this.returnEndDate) {
        records = records.filter(r => r.date <= this.returnEndDate)
      }

      return records
    },
    // 收益率历史记录 - 分页
    paginatedReturnRecords() {
      const start = (this.returnCurrentPage - 1) * this.returnPageSize
      const end = start + this.returnPageSize
      return this.filteredReturnRecords.slice(start, end)
    },
    // 收益率历史记录 - 总页数
    returnTotalPages() {
      return Math.ceil(this.filteredReturnRecords.length / this.returnPageSize)
    }
  },
  async mounted() {
    await this.checkAuth()
    await this.loadData()
  },
  watch: {
    navRecords: {
      handler() {
        this.updateChart()
        this.updateReturnChart()
      },
      deep: true
    },
    selectedPeriod() {
      this.updateChart()
      this.updateReturnChart()
    },
    // 净值历史记录 - 筛选条件改变时重置到第一页
    navStartDate() {
      this.navCurrentPage = 1
    },
    navEndDate() {
      this.navCurrentPage = 1
    },
    // 收益率历史记录 - 筛选条件改变时重置到第一页
    returnStartDate() {
      this.returnCurrentPage = 1
    },
    returnEndDate() {
      this.returnCurrentPage = 1
    }
  },
  methods: {
    async checkAuth() {
      // 检查是否已登录
      if (!api.isAuthenticated()) {
        this.$router.push('/login')
        return
      }

      const { userInfo } = api.getAuthInfo()
      if (!userInfo) {
        this.$router.push('/login')
        return
      }

      this.userEmail = userInfo.email

      // 如果是管理员，跳转到管理页面
      if (userInfo.role === 'ADMIN') {
        this.$router.push('/admin')
      }
    },
    async handleLogout() {
      api.logout()
    },
    async loadData() {
      try {
        const { userInfo } = api.getAuthInfo()
        if (!userInfo) return

        console.log('🚀 加载客户数据...', userInfo.email)

        // 获取客户信息
        const clientResponse = await api.getClientByEmail(userInfo.email)

        if (!clientResponse.success || !clientResponse.data) {
          console.error('❌ 获取客户信息失败')
          return
        }

        const client = clientResponse.data
        console.log('📦 原始客户数据:', client)
        console.log('📦 客户余额:', client.balance)
        console.log('📦 客户份额:', client.shares)
        console.log('📦 初始金额:', client.initialAmount)
        console.log('📦 加入日期:', client.joinDate)

        this.clientInfo = {
          clientId: client.clientId,
          name: client.name,
          email: client.email,
          balance: client.balance,
          joinDate: client.joinDate // 添加加入日期
        }

        console.log('✅ 客户信息:', this.clientInfo)

        // 使用客户表中的当前余额作为当前价值
        this.currentValue = client.balance || 0
        console.log('💰 当前价值:', this.currentValue)

        // 获取净值曲线（客户净值快照）
        const navResponse = await api.getClientNavCurve(client.clientId)

        if (navResponse.success && navResponse.data && navResponse.data.length > 0) {
          const records = navResponse.data

          // 按创建时间降序排序（最新的在前）- 使用id作为排序依据，因为id是自增的
          records.sort((a, b) => b.id - a.id)

          this.navRecords = records.map((record) => {
            return {
              date: record.date,
              pool_id: record.poolId || 'N/A',
              nav_amount: record.personalNavValue, // 使用个人净值
              pool_nav: record.poolNavValue, // 池子净值
              balance: record.balance, // 客户余额
              personal_nav: record.personalNavValue, // 个人净值
              daily_profit: record.dailyProfit || 0, // 日收益
              total_profit: record.totalProfit || 0, // 累计收益
              change: record.dailyProfit || 0 // 使用日收益作为变化值
            }
          })

          console.log('✅ 净值记录:', this.navRecords.length, '条')

          // 按日期分组，每个日期只保留最新的一条记录（id最大的）
          const dateGroups = {}
          records.forEach(r => {
            if (!dateGroups[r.date] || r.id > dateGroups[r.date].id) {
              dateGroups[r.date] = r
            }
          })

          // 将分组后的记录转换为数组，并按日期降序排序
          const uniqueDateRecords = Object.values(dateGroups).sort((a, b) => {
            const dateA = new Date(a.date)
            const dateB = new Date(b.date)
            return dateB - dateA
          })

          console.log('📊 按日期分组后的记录数:', uniqueDateRecords.length)

          // ✅ 正确的收益计算逻辑：使用 total_profit 字段
          // 当日收益 = 最新记录的 daily_profit
          if (uniqueDateRecords.length >= 1) {
            this.dailyChange = uniqueDateRecords[0].dailyProfit || 0
            console.log('💰 当日收益:', this.dailyChange)
          }

          // 7天收益计算逻辑：
          // - 如果数据 >= 7天：7天收益 = (当日余额 - 7天前余额) - 这7天的追加投入
          //   使用total_profit差值可以自动扣除追加投入：7天收益 = 当日total_profit - 7天前total_profit
          // - 如果数据 < 7天：7天收益 = 当前余额 - 总投入 = 当前total_profit
          if (uniqueDateRecords.length >= 1) {
            const latestRecord = uniqueDateRecords[0]
            const latestBalance = latestRecord.balance || 0
            const latestProfit = latestRecord.totalProfit || 0
            const latestDate = new Date(latestRecord.date)
            const earliestRecord = uniqueDateRecords[uniqueDateRecords.length - 1]
            const earliestDate = new Date(earliestRecord.date)

            // 计算最早记录到最新记录的天数差
            const daysDiff = Math.floor((latestDate - earliestDate) / (1000 * 60 * 60 * 24))

            if (daysDiff >= 7) {
              // 数据 >= 7天，查找7天前的记录
              const sevenDaysAgo = new Date(latestDate)
              sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)

              // 找到7天前日期当天或之前最接近的记录
              let sevenDaysAgoRecord = null
              for (let i = 0; i < uniqueDateRecords.length; i++) {
                const recordDate = new Date(uniqueDateRecords[i].date)
                if (recordDate <= sevenDaysAgo) {
                  sevenDaysAgoRecord = uniqueDateRecords[i]
                  break
                }
              }

              if (sevenDaysAgoRecord) {
                const sevenDaysAgoBalance = sevenDaysAgoRecord.balance || 0
                const sevenDaysAgoProfit = sevenDaysAgoRecord.totalProfit || 0
                // 使用total_profit差值，自动扣除这7天的追加投入
                this.weekChange = latestProfit - sevenDaysAgoProfit
                console.log('💰 7天收益(数据>=7天):', this.weekChange, '= total_profit差值 =', latestProfit, '-', sevenDaysAgoProfit,
                  '| 余额差值:', latestBalance - sevenDaysAgoBalance, '(7天前:', sevenDaysAgoRecord.date, ')')
              } else {
                // 理论上不应该走到这里
                this.weekChange = latestProfit
                console.log('💰 7天收益(异常):', this.weekChange, '= 当前total_profit')
              }
            } else {
              // 数据 < 7天，直接使用当前total_profit（当前余额 - 总投入）
              this.weekChange = latestProfit
              console.log('💰 7天收益(数据<7天):', this.weekChange, '= 当前total_profit = 当前余额', latestBalance, '- 总投入 (数据天数:', daysDiff, '天)')
            }
          }

          // 30天收益计算逻辑：
          // - 如果数据 >= 30天：30天收益 = (当日余额 - 30天前余额) - 这30天的追加投入
          //   使用total_profit差值可以自动扣除追加投入：30天收益 = 当日total_profit - 30天前total_profit
          // - 如果数据 < 30天：30天收益 = 当前余额 - 总投入 = 当前total_profit
          if (uniqueDateRecords.length >= 1) {
            const latestRecord = uniqueDateRecords[0]
            const latestBalance = latestRecord.balance || 0
            const latestProfit = latestRecord.totalProfit || 0
            const latestDate = new Date(latestRecord.date)
            const earliestRecord = uniqueDateRecords[uniqueDateRecords.length - 1]
            const earliestDate = new Date(earliestRecord.date)

            // 计算最早记录到最新记录的天数差
            const daysDiff = Math.floor((latestDate - earliestDate) / (1000 * 60 * 60 * 24))

            if (daysDiff >= 30) {
              // 数据 >= 30天，查找30天前的记录
              const thirtyDaysAgo = new Date(latestDate)
              thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30)

              // 找到30天前日期当天或之前最接近的记录
              let thirtyDaysAgoRecord = null
              for (let i = 0; i < uniqueDateRecords.length; i++) {
                const recordDate = new Date(uniqueDateRecords[i].date)
                if (recordDate <= thirtyDaysAgo) {
                  thirtyDaysAgoRecord = uniqueDateRecords[i]
                  break
                }
              }

              if (thirtyDaysAgoRecord) {
                const thirtyDaysAgoBalance = thirtyDaysAgoRecord.balance || 0
                const thirtyDaysAgoProfit = thirtyDaysAgoRecord.totalProfit || 0
                // 使用total_profit差值，自动扣除这30天的追加投入
                this.monthChange = latestProfit - thirtyDaysAgoProfit
                console.log('💰 30天收益(数据>=30天):', this.monthChange, '= total_profit差值 =', latestProfit, '-', thirtyDaysAgoProfit,
                  '| 余额差值:', latestBalance - thirtyDaysAgoBalance, '(30天前:', thirtyDaysAgoRecord.date, ')')
              } else {
                // 理论上不应该走到这里
                this.monthChange = latestProfit
                console.log('💰 30天收益(异常):', this.monthChange, '= 当前total_profit')
              }
            } else {
              // 数据 < 30天，直接使用当前total_profit（当前余额 - 总投入）
              this.monthChange = latestProfit
              console.log('💰 30天收益(数据<30天):', this.monthChange, '= 当前total_profit = 当前余额', latestBalance, '- 总投入 (数据天数:', daysDiff, '天)')
            }
          }
        } else {
          console.log('⚠️ 暂无净值记录')
        }

        // 获取客户所属的池子信息
        if (client.poolId) {
          try {
            const poolResponse = await api.getPoolByPoolId(client.poolId)
            if (poolResponse.success && poolResponse.data) {
              const pool = poolResponse.data
              // 计算客户在池子中的权重（份额占比）
              const weight = pool.totalShares > 0 ? client.shares / pool.totalShares : 0

              this.poolInfo = [{
                pool_id: pool.poolId,
                pool_name: pool.name,
                weight: weight,
                amount: client.initialAmount || 0  // 使用初始投入金额
              }]

              // 设置最近更新净值的日期和当前池子净值
              this.lastNavUpdateDate = pool.lastNavUpdateDate || ''
              this.currentPoolNavValue = pool.currentNavValue || 1.0
              console.log('📅 最近更新净值日期:', this.lastNavUpdateDate)
              console.log('📊 当前池子净值:', this.currentPoolNavValue)
            }
          } catch (error) {
            console.error('获取池子信息失败:', error)
            // 如果获取失败，使用默认值
            this.poolInfo = [{
              pool_id: client.poolId || 'N/A',
              pool_name: '策略池',
              weight: 0,
              amount: client.initialAmount || 0
            }]
          }
        } else {
          this.poolInfo = []
        }
      } catch (error) {
        console.error('加载数据失败:', error)
      }
    },
    changePeriod(period) {
      this.selectedPeriod = period
    },
    updateChart() {
      console.log('📊 updateChart 被调用, navRecords:', this.navRecords)

      if (!this.navRecords || this.navRecords.length === 0) {
        console.log('⚠️ 没有净值记录，图表设置为null')
        this.chartOption = null
        return
      }

      // 过滤掉早于客户加入日期的记录
      let filteredRecords = [...this.navRecords]
      if (this.clientInfo.joinDate) {
        filteredRecords = filteredRecords.filter(r => r.date >= this.clientInfo.joinDate)
        console.log(`📊 过滤加入日期 >= ${this.clientInfo.joinDate}，剩余记录数:`, filteredRecords.length)
      }

      // 反转为升序（从旧到新）
      filteredRecords = filteredRecords.reverse()

      // 根据选择的时间段过滤数据
      if (this.selectedPeriod === '7') {
        filteredRecords = filteredRecords.slice(-7)
      } else if (this.selectedPeriod === '30') {
        filteredRecords = filteredRecords.slice(-30)
      }
      // 'all' 则显示全部数据

      console.log('📊 过滤后的记录数:', filteredRecords.length)

      // 准备图表数据
      const dates = filteredRecords.map(r => r.date)
      const values = filteredRecords.map(r => r.nav_amount)

      console.log('📊 图表数据 - dates:', dates, 'values:', values)

      // 配置 ECharts 选项
      this.chartOption = {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(30, 30, 40, 0.95)',
          borderColor: '#4a5568',
          borderWidth: 1,
          textStyle: {
            color: '#e2e8f0'
          },
          formatter: (params) => {
            const param = params[0]
            return `
              <div style="padding: 4px 0;">
                <div style="margin-bottom: 4px; font-weight: 600;">${param.name}</div>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <span style="display: inline-block; width: 10px; height: 10px; border-radius: 50%; background: ${param.color};"></span>
                  <span>净值：</span>
                  <span style="font-weight: 600;">${parseFloat(param.value + 1).toFixed(2)}</span>
                </div>
              </div>
            `
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: dates,
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#4a5568'
            }
          },
          axisLabel: {
            color: '#a0aec0',
            fontSize: 12,
            formatter: (value) => {
              // 移动端显示简短日期格式 MM-DD
              if (window.innerWidth <= 768) {
                const date = new Date(value)
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const day = String(date.getDate()).padStart(2, '0')
                return `${month}-${day}`
              }
              return value
            },
            rotate: window.innerWidth <= 768 ? 45 : 0, // 移动端旋转45度
            interval: window.innerWidth <= 768 ? 'auto' : 0 // 移动端自动间隔
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#a0aec0',
            fontSize: 12,
            formatter: (value) => {
              return value.toFixed(2)
            }
          },
          splitLine: {
            lineStyle: {
              color: '#2d3748',
              type: 'dashed'
            }
          }
        },
        series: [
          {
            name: '净值',
            type: 'line',
            data: values,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {
              width: 3,
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  { offset: 0, color: '#4f9eff' },
                  { offset: 1, color: '#7b9eff' }
                ]
              }
            },
            itemStyle: {
              color: '#4f9eff',
              borderColor: '#fff',
              borderWidth: 2
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(79, 158, 255, 0.3)' },
                  { offset: 1, color: 'rgba(79, 158, 255, 0.05)' }
                ]
              }
            },
            emphasis: {
              focus: 'series',
              itemStyle: {
                color: '#4f9eff',
                borderColor: '#fff',
                borderWidth: 3,
                shadowBlur: 10,
                shadowColor: 'rgba(79, 158, 255, 0.5)'
              }
            }
          }
        ]
      }
    },
    updateReturnChart() {
      if (!this.navRecords || this.navRecords.length === 0) {
        this.returnChartOption = null
        return
      }

      // 过滤掉早于客户加入日期的记录
      let filteredRecords = [...this.navRecords]
      if (this.clientInfo.joinDate) {
        filteredRecords = filteredRecords.filter(r => r.date >= this.clientInfo.joinDate)
      }

      // 反转为升序（从旧到新）
      filteredRecords = filteredRecords.reverse()

      // 根据选择的时间段过滤数据
      if (this.selectedPeriod === '7') {
        filteredRecords = filteredRecords.slice(-7)
      } else if (this.selectedPeriod === '30') {
        filteredRecords = filteredRecords.slice(-30)
      }
      // 'all' 则显示全部数据

      if (filteredRecords.length === 0) {
        this.returnChartOption = null
        return
      }

      // 计算收益率（基于个人净值）
      const dates = filteredRecords.map(r => r.date)
      const returnRates = filteredRecords.map(r => {
        // 个人收益率 = personal_nav_value × 100%
        // personal_nav_value 已经是收益率的小数形式，例如 0.25 表示 25% 收益
        const personalNav = r.personal_nav || 0
        return (personalNav * 100).toFixed(2)
      })

      // 配置 ECharts 选项
      this.returnChartOption = {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(30, 30, 40, 0.95)',
          borderColor: '#4a5568',
          borderWidth: 1,
          textStyle: {
            color: '#e2e8f0'
          },
          formatter: (params) => {
            const param = params[0]
            const rate = parseFloat(param.value)
            const color = rate >= 0 ? '#10b981' : '#ef4444'
            const sign = rate >= 0 ? '+' : ''
            return `
              <div style="padding: 4px 0;">
                <div style="margin-bottom: 4px; font-weight: 600;">${param.name}</div>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <span style="display: inline-block; width: 10px; height: 10px; border-radius: 50%; background: ${color};"></span>
                  <span>收益率：</span>
                  <span style="font-weight: 600; color: ${color};">${sign}${param.value}%</span>
                </div>
              </div>
            `
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: dates,
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#4a5568'
            }
          },
          axisLabel: {
            color: '#a0aec0',
            fontSize: 12,
            formatter: (value) => {
              // 移动端显示简短日期格式 MM-DD
              if (window.innerWidth <= 768) {
                const date = new Date(value)
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const day = String(date.getDate()).padStart(2, '0')
                return `${month}-${day}`
              }
              return value
            },
            rotate: window.innerWidth <= 768 ? 45 : 0, // 移动端旋转45度
            interval: window.innerWidth <= 768 ? 'auto' : 0 // 移动端自动间隔
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#a0aec0',
            fontSize: 12,
            formatter: (value) => {
              return value.toFixed(1) + '%'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#2d3748',
              type: 'dashed'
            }
          }
        },
        series: [
          {
            name: '收益率',
            type: 'line',
            data: returnRates,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {
              width: 3,
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  { offset: 0, color: '#10b981' },
                  { offset: 1, color: '#34d399' }
                ]
              }
            },
            itemStyle: {
              color: '#10b981',
              borderColor: '#fff',
              borderWidth: 2
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(16, 185, 129, 0.3)' },
                  { offset: 1, color: 'rgba(16, 185, 129, 0.05)' }
                ]
              }
            },
            emphasis: {
              focus: 'series',
              itemStyle: {
                color: '#10b981',
                borderColor: '#fff',
                borderWidth: 3,
                shadowBlur: 10,
                shadowColor: 'rgba(16, 185, 129, 0.5)'
              }
            },
            markLine: {
              silent: true,
              symbol: 'none',
              lineStyle: {
                color: '#718096',
                type: 'solid',
                width: 1
              },
              label: {
                show: true,
                position: 'end',
                formatter: '0%',
                color: '#a0aec0',
                fontSize: 11
              },
              data: [
                {
                  yAxis: 0,
                  name: '基准线'
                }
              ]
            }
          }
        ]
      }
    },
    formatCurrency(value) {
      if (!value) return '$0.0'
      // 金额保留一位小数并四舍五入
      return '$' + parseFloat(value).toFixed(1)
    },
    formatNavValue(value) {
      if (!value) return '0.00元/份'
      // 净值保留两位小数并四舍五入
      return parseFloat(value).toFixed(2) + '元/份'
    },
    formatChange(value) {
      if (!value) return '$0.0'
      const prefix = value > 0 ? '+' : ''
      // 金额保留一位小数并四舍五入
      return prefix + '$' + parseFloat(value).toFixed(1)
    },
    getChangeClass(change) {
      if (!change) return ''
      return change > 0 ? 'positive' : change < 0 ? 'negative' : ''
    },
    formatReturnRate(rate) {
      const numRate = parseFloat(rate)
      const prefix = numRate > 0 ? '+' : ''
      return prefix + numRate.toFixed(2) + '%'
    },
    getReturnClass(rate) {
      const numRate = parseFloat(rate)
      if (!numRate) return ''
      return numRate > 0 ? 'positive' : numRate < 0 ? 'negative' : ''
    },
    // 净值历史记录分页
    navPrevPage() {
      if (this.navCurrentPage > 1) {
        this.navCurrentPage--
      }
    },
    navNextPage() {
      if (this.navCurrentPage < this.navTotalPages) {
        this.navCurrentPage++
      }
    },
    // 收益率历史记录分页
    returnPrevPage() {
      if (this.returnCurrentPage > 1) {
        this.returnCurrentPage--
      }
    },
    returnNextPage() {
      if (this.returnCurrentPage < this.returnTotalPages) {
        this.returnCurrentPage++
      }
    }
  }
}
</script>

<style scoped>
.dashboard-page {
  min-height: 100vh;
  background: var(--bg);
}

.header {
  background: var(--card);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-badge {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, var(--primary) 0%, #7b9eff 100%);
  color: #fff;
  font-weight: 700;
  font-size: 18px;
}

h1 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: var(--text);
}

.muted {
  color: var(--muted);
  font-size: 13px;
  margin-top: 2px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.last-update-info {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 6px;
}

.update-label {
  color: var(--muted);
  font-size: 13px;
}

.update-date {
  color: var(--text);
  font-size: 13px;
  font-weight: 600;
}

.user-email {
  color: var(--muted);
  font-size: 14px;
}

.btn-secondary {
  height: 36px;
  padding: 0 16px;
  background: transparent;
  border: 1px solid var(--border);
  border-radius: 8px;
  color: var(--text);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-secondary:hover {
  border-color: var(--primary);
  color: var(--primary);
}

.main-content {
  padding: 32px 0;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Overview Section */
.overview-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.stat-card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 24px;
  transition: all 0.3s;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.stat-card.primary {
  background: linear-gradient(135deg, var(--primary) 0%, #7b9eff 100%);
  border: none;
}

.stat-card.primary .stat-label,
.stat-card.primary .stat-value,
.stat-card.primary .stat-note {
  color: #fff;
}

.stat-label {
  font-size: 13px;
  color: var(--muted);
  margin-bottom: 8px;
}

.stat-value {
  font-size: 32px;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 4px;
}

.stat-value.positive {
  color: #4ade80;
}

.stat-value.negative {
  color: #f87171;
}

.stat-note {
  font-size: 12px;
  color: var(--muted);
}

/* Chart Section */
.chart-section {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 32px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.section-header h2 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: var(--text);
}

.chart-controls {
  display: flex;
  gap: 8px;
}

.period-btn {
  padding: 6px 14px;
  background: transparent;
  border: 1px solid var(--border);
  border-radius: 8px;
  color: var(--muted);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.period-btn.active {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
}

.chart-container {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border-radius: 12px;
  padding: 20px;
}

.chart {
  width: 100%;
  height: 100%;
}

.chart-empty {
  color: var(--muted);
  font-size: 14px;
}

/* Pool Section */
.pool-section {
  margin-bottom: 32px;
}

.pool-section h2 {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 16px;
  color: var(--text);
}

.pool-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}

.pool-card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 20px;
}

.pool-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border);
}

.pool-name {
  font-size: 16px;
  font-weight: 600;
  color: var(--text);
}

.pool-id {
  font-size: 12px;
  color: var(--muted);
  background: var(--input);
  padding: 4px 8px;
  border-radius: 6px;
}

.pool-stats {
  display: grid;
  gap: 12px;
}

.pool-stat {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pool-stat .label {
  font-size: 13px;
  color: var(--muted);
}

.pool-stat .value {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
}

/* History Section */
.history-section {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 32px;
}

.history-section h2 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: var(--text);
}

.history-tabs {
  display: flex;
  gap: 8px;
}

.tab-btn {
  height: 40px;
  padding: 0 20px;
  background: transparent;
  border: 1px solid var(--border);
  border-radius: 10px;
  color: var(--muted);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
}

.tab-btn:hover {
  background: var(--input);
  border-color: var(--primary);
  color: var(--text);
}

.tab-btn.active {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
  box-shadow: 0 4px 12px rgba(79, 158, 255, 0.3);
}

.date-filter {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.date-filter label {
  font-size: 13px;
  color: var(--muted);
  font-weight: 500;
}

.date-input {
  height: 36px;
  padding: 0 12px;
  background: var(--input);
  border: 1px solid var(--border);
  border-radius: 8px;
  color: var(--text);
  font-size: 13px;
  transition: all 0.2s;
}

.date-input:focus {
  outline: none;
  border-color: var(--primary);
  background: var(--card);
}

.reset-btn {
  height: 36px;
  padding: 0 16px;
  background: rgba(79, 158, 255, 0.1);
  border: 1px solid rgba(79, 158, 255, 0.3);
  border-radius: 8px;
  color: var(--primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.reset-btn:hover {
  background: rgba(79, 158, 255, 0.2);
  border-color: var(--primary);
}

.table-container {
  background: transparent;
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
  margin-top: 16px;
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--border);
}

.page-btn {
  height: 36px;
  padding: 0 16px;
  background: var(--input);
  border: 1px solid var(--border);
  border-radius: 8px;
  color: var(--text);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
  background: var(--card-2);
  border-color: var(--primary);
  color: var(--primary);
}

.page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.page-info {
  font-size: 13px;
  color: var(--muted);
  font-weight: 500;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th {
  background: var(--card-2);
  padding: 14px 16px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: var(--muted);
  border-bottom: 1px solid var(--border);
}

td {
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text);
  border-bottom: 1px solid var(--border);
}

td.amount {
  font-weight: 600;
}

td.positive {
  color: #4ade80;
  font-weight: 600;
}

td.negative {
  color: #f87171;
  font-weight: 600;
}

td.empty {
  text-align: center;
  padding: 40px;
  color: var(--muted);
}

@media (max-width: 768px) {
  /* Header 移动端适配 */
  .header-content {
    padding: 12px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .brand {
    width: 100%;
  }

  .brand-badge {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }

  h1 {
    font-size: 16px;
  }

  .muted {
    font-size: 12px;
  }

  .header-actions {
    width: 100%;
    flex-wrap: wrap;
    gap: 8px;
  }

  .last-update-info {
    order: 1;
    width: 100%;
    padding: 8px 12px;
    font-size: 12px;
  }

  .update-label {
    font-size: 12px;
  }

  .update-date {
    font-size: 12px;
  }

  .user-email {
    order: 2;
    font-size: 13px;
    flex: 1;
  }

  .btn-secondary {
    order: 3;
    font-size: 13px;
    padding: 8px 16px;
    height: auto;
    white-space: nowrap;
  }

  /* Main Content */
  .dashboard-container {
    padding: 16px;
  }

  .dashboard-content {
    padding: 16px;
  }

  .overview-section {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .stat-card {
    padding: 16px;
  }

  .stat-label {
    font-size: 12px;
  }

  .stat-value {
    font-size: 20px;
  }

  .stat-note {
    font-size: 11px;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .section-header h2 {
    font-size: 16px;
  }

  .chart-controls {
    width: 100%;
    justify-content: flex-start;
  }

  .period-btn {
    flex: 1;
    font-size: 12px;
    padding: 6px 10px;
  }

  .chart-container {
    height: 300px;
  }

  .chart-section {
    padding: 16px;
    margin-bottom: 16px;
  }

  .pool-grid {
    grid-template-columns: 1fr;
  }

  .pool-card {
    padding: 16px;
  }

  .history-section {
    padding: 16px;
    margin-bottom: 16px;
  }

  .history-tabs {
    width: 100%;
    flex-direction: row;
  }

  .tab-btn {
    flex: 1;
    font-size: 13px;
    padding: 0 12px;
    height: 36px;
  }

  .date-filter {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .date-filter label {
    font-size: 12px;
  }

  .date-input {
    width: 100%;
    height: 40px;
    font-size: 14px;
  }

  .reset-btn {
    width: 100%;
    height: 40px;
  }

  .table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  table {
    min-width: 600px;
  }

  th {
    padding: 10px 12px;
    font-size: 12px;
    white-space: nowrap;
  }

  td {
    padding: 10px 12px;
    font-size: 13px;
  }

  .pagination {
    flex-direction: column;
    gap: 12px;
  }

  .page-btn {
    width: 100%;
    height: 40px;
  }

  .page-info {
    font-size: 12px;
    text-align: center;
  }
}
</style>

